export const createTenderData =
  ({ NO_VARIANCE }) =>
  (tender, index) => {
    if (tender === undefined) return null;

    const {
      currentFloat,
      defaultFloat = 0,
      isEditable,
      isForeignTender = false,
      foreignAmount,
      currencyCode,
    } = tender;
    const validation = {
      success: true,
    };

    const initialTender = {
      actualAmount: currentFloat,
      defaultFloat,
      expectedPickupAmount: currentFloat,
      index,
      isEditable,
      isForeignTender,
      isOpenable: isEditable,
      isDisabled: !isEditable,
      variance: 0,
      varianceReason: NO_VARIANCE,
      varianceExplanation: '',
      validation,
    };

    if (tender.tenderType !== 'CASH') return { ...initialTender, ...tender };

    const baseTender = {
      ...initialTender,
      ...tender,
      currentCount: 0,
    };

    return isForeignTender
      ? {
          ...baseTender,
          actualAmount: foreignAmount,
          expectedPickupAmount: foreignAmount,
        }
      : {
          ...baseTender,
          actualAmount: currentFloat - defaultFloat,
          expectedPickupAmount: currentFloat - defaultFloat,
          primaryCurrency: true,
          subTenderType: currencyCode,
        };
  };
